import { mdiAsterisk, mdiBellOutline, mdiStarOutline } from '@mdi/js'
import Icon from '@mdi/react'

import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import { TCompliancesDataAsObject, TMyLearning } from '@/types/tasksApprovals'

const LeftSide = ({ iconColor, textColor, totals }: { iconColor: string; textColor: string; totals: TCompliancesDataAsObject }) => {
    return (
        <Flex flexDir="column" gap="6px" justifyContent="space-between">
            {(['MANDATORY', 'REQUIRED', 'OPTIONAL'] as TMyLearning[]).map((type) => {
                const icon = type === 'MANDATORY' ? mdiAsterisk : type === 'REQUIRED' ? mdiBellOutline : mdiStarOutline
                if (totals[type] > 0) {
                    return (
                        <Flex gap="4px" alignItems="center" key={type}>
                            <Icon path={icon} size="16px" color={iconColor} />
                            <Text textAlign="left" fontSize="12px" color={textColor}>
                                {totals[type]}
                            </Text>
                            <Text fontSize="12px" textTransform="uppercase" color={textColor}>
                                {type}
                            </Text>
                        </Flex>
                    )
                }
            })}
        </Flex>
    )
}

export default LeftSide
